module.exports = __webpack_public_path__ + "media/components/src/assets/images/navigate_next/navigate_next-3e15c2a47ac8cb4d7c672c3cf7bbf3ec.png";